import { Dialog, DialogContent, DialogHeader, DialogTitle } from "components/app/dialog/dialog";
import ImageUrlProfile from "components/app/image-url/ImageUrlProfile";
import SearchBar from "components/app/search-bar/SearchBar";
import { Card } from "components/ui/card";

import { X } from "lucide-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import InfiniteScroll from "react-infinite-scroll-component";
import { Link } from "react-router-dom";
import { AppLog } from "services";
import { FriendStatus, StatusMsg } from "utils";

import { profileVerified } from "assets";
import { Button } from "components/ui/button";
import { ShimmerDialogSuggestionFriend } from "components/app/shrimmer/Shrimmer";
import { useDialogSuggestionFriendStore } from "store/dialog/useDialogSuggestionFriendStore";

interface DialogProps {
  isDialogOpen: boolean;
  looking: string;
  setIsDialogOpen: (value: boolean) => void;
}

export default function DailogSuggestionFriend({ isDialogOpen, looking, setIsDialogOpen }: DialogProps) {
  const { t } = useTranslation();

  const { users, appRecord, initializePage, fetchSuggestionFriends, onFollowingUser, onUnFollowingUser, onUninterestUser, disposePage } = useDialogSuggestionFriendStore();

  const [searchText, setSearchText] = useState<string>("");

  useEffect(() => {
    const loadInitialSuggestionFriends = async () => {
      try {
        initializePage(looking);
      } catch (error) {
        AppLog.show({
          message: `[loadInitialSuggestionFriends]`,
          status: StatusMsg.error,
          error,
        });
      }
    };

    if (isDialogOpen) {
      loadInitialSuggestionFriends();
    } else {
      disposePage();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDialogOpen]);

  useEffect(() => {
    if (isDialogOpen) {
      fetchSuggestionFriends(looking, searchText, true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText]);

  return (
    <Dialog open={isDialogOpen}>
      <DialogContent isShowBtnXClose={false} className="max-w-[300px] md:max-w-[500px] lg:max-w-[700px] h-[calc(100vh-80px)]">
        <DialogHeader>
          <DialogTitle className="text-center ">{t(`Suggestion ${looking === "" ? "Friend" : looking}`)}</DialogTitle>

          <div
            className="absolute flex items-center justify-center right-3 top-1 z-40 cursor-pointer rounded-full hover:bg-accent hover:text-accent-foreground w-[36px] h-[36px] p-2"
            onClick={() => setIsDialogOpen(false)}
          >
            <X />
          </div>
        </DialogHeader>

        <div className="">
          <div className="">
            <SearchBar name="SearhAccount" onValueChange={(result) => setSearchText(result)} />
          </div>
          {appRecord.isLoading() ? (
            <ShimmerDialogSuggestionFriend />
          ) : (
            <div id="scrollableDiv" className="mt-4 h-[calc(100vh-215px)] overflow-y-auto custom-scrollbar">
              <InfiniteScroll
                className={`relative h-[calc(100vh-215px)]`}
                dataLength={users.length}
                next={() => {
                  if (appRecord.canLoadMore()) {
                    fetchSuggestionFriends(looking, searchText, false);
                  }
                }}
                scrollThreshold="90%"
                hasMore={appRecord.canLoadMore()}
                scrollableTarget="scrollableDiv"
                loader={
                  <div className="absolute bottom-2 left-0 w-full flex justify-center">
                    {/* <LoaderCircle
                            size={30}
                            className="animate-spin text-yellow-400"
                          /> */}
                  </div>
                }
                endMessage={
                  <>
                    {appRecord.isNoLoadMore() && (
                      <p className="absolute bottom-0 left-0 w-full text-center">
                        <b>Nothing more to load!</b>
                      </p>
                    )}
                  </>
                }
              >
                <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 mb-20">
                  {users.map((user: any) => {
                    return (
                      <div key={user.id} className="relative  flex-shrink-0 cursor-pointer rounded-xl overflow-hidden">
                        <Card key={user.id} className="rounded-md space-y-2 ">
                          <Link to={`/profile?id=${user?.id}&feed`} className="cursor-pointer relative overflow-hidden">
                            {user.status === "Unpublished" && (
                              <div className="absolute z-10 top-8 -right-16 rotate-45 w-full bg-red-700 text-white text-center font-sans py-1 opacity-80">
                                <span>{user.status}</span>
                              </div>
                            )}
                            <ImageUrlProfile className="w-full object-cover h-[200px] rounded-t-md" user={user} />
                            {/* Name */}
                            <div className="p-2">
                              <div className="flex">
                                <h1 className="font-semibold text-lg line-clamp-1">{user?.name}</h1>
                                {user?.is_verified === "Yes" ? (
                                  <>
                                    <div className="flex items-center justify-center pt-0.5 ml-1">
                                      <img src={profileVerified} style={{ width: 24, height: 24 }} alt="" />
                                    </div>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </div>
                              <p className={`line-clamp-1 ${user?.bio === "" ? "invisible" : ""}`}>{user?.bio !== "" ? user?.bio : "NoBio"}</p>
                            </div>
                          </Link>

                          {/* Follower Post Like */}
                          <div className="grid grid-cols-3 text-center">
                            <div className="">
                              <h1 className="font-semibold">{user?.no_of_follower}</h1>
                              <p className="text-xs">Followers</p>
                            </div>
                            <div className="">
                              <h1 className="font-semibold">{user?.no_of_post}</h1>
                              <p className="text-xs">Posts</p>
                            </div>
                            <div className="">
                              <h1 className="font-semibold">{user?.no_of_like}</h1>
                              <p className="text-xs">Likes</p>
                            </div>
                          </div>

                          <div className="flex flex-row p-2 space-x-2">
                            {FriendStatus.getType(user.friend_status) === FriendStatus.follow ||
                            FriendStatus.getType(user.friend_status) === FriendStatus.follower ||
                            FriendStatus.getType(user.friend_status) === FriendStatus.none ? (
                              <Button variant="secondary" onClick={() => onUninterestUser(`${user.id}`)} size={"sm"} className="flex-1">
                                {t("Remove")}
                              </Button>
                            ) : (
                              <></>
                            )}
                            {FriendStatus.getType(user.friend_status) === FriendStatus.following ? (
                              <Button variant="destructive" onClick={() => onUnFollowingUser(user)} size={"sm"} className="flex flex-1">
                                {t("Following")}
                              </Button>
                            ) : (
                              <Button variant="destructive" onClick={() => onFollowingUser(user)} size={"sm"} className="flex flex-1">
                                {t("Follow")}
                              </Button>
                            )}
                          </div>
                        </Card>
                      </div>
                    );
                  })}
                </div>
              </InfiniteScroll>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}

